import { createElement } from 'react';
import { getIntents, provider } from '../intent';
export function runProviders(intentMap, element) {
    const providers = getIntents(provider, intentMap);
    if (providers) {
        let currentElement = element;
        providers.forEach(([Context, value])=>{
            currentElement = createElement(Context.Provider, {
                value
            }, currentElement);
        });
        return currentElement;
    }
    return element;
}

//# sourceMappingURL=provider.js.map